<template lang='pug'>
  .discover-events(:class='{ "no-top-padding": isMobileApp }')
    banner(page='events_index_page')
    Events(:event='event' :store ='store')
    .empty-view(v-if='events.length===0' v-text='$t("bookingService.empty")')
</template>

<i18n>
{
  "lng_en": {
    "bookingService": {
      "empty": "There are currently no store events. Please check back soon."
    }
  },
  "lng_id": {
    "bookingService": {
      "empty": "There are currently no store events. Please check back soon."
    }
  },
  "lng_zh": {
    "bookingService": {
      "empty": "目前沒有門店活動。請密切留意。"
    }
  },
  "lng_th": {
    "bookingService": {
      "empty": "ยังไม่มีกิจกรรมที่สาขาในตอนนี้ โปรดกลับมาดูอีกครั้งในเร็ว ๆ นี้"
    }
  },
  "lng_ko": {
    "bookingService": {
      "empty": "현재 진행 중인 매장 이벤트가 없습니다. 나중에 다시 확인해주세요. "
    }
  }
}
</i18n>

<script>
import { createNamespacedHelpers } from 'vuex'
import Banner from './reusable/banner.vue'
import Events from './reusable/events.vue'
import { fullUrl } from '@/modules/services/utilities'

const { mapState, mapGetters } = createNamespacedHelpers('bookingService')

export default {
  name: 'DiscoverEventShow',
  components: { Banner, Events },
  computed: {
    ...mapGetters(['isMobileApp', 'objectById']),
    ...mapState(['events', 'stores']),
    event () {
      return this.objectById('events', this.eventSlug)
    },
    eventSlug () {
      return this.$route.params.name
    },
    store () {
      return this.objectById('stores', this.storeId)
    },
    storeId () {
      return this.$route.params.id
    }
  },
  mounted () {
    const event = this.event
    if (event) {
      this.$store.commit('setSeoMetaTitle', event.attributes.name)
      this.$store.commit('setSeoMetaDescription', event.attributes.description)
      this.$store.commit('setSeoUpdate', true)
      this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
      if (!this.$route.hash) {
        this.$scrollTo('#header', 200)
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .discover-events {
    @include media-breakpoint-down(md) {
      padding-right: 5px;
      padding-left: 5px;
    }

    @include media-breakpoint-down(sm) {
      padding: 10px;
    }

    &.no-top-padding {
      padding-top: 0;
    }

    .empty-view {
      padding-top: 16px;
      line-height: 18px;
    }
  }
</style>
